import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessAccountNotificationSettings } from "@/components/PortfolioSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { RequireFeatureFlag } from "@/components/Routing/RequireFeatureFlag";

import { accountRoutes } from "./routes";

export const accountRoute = [
  {
    path: accountRoutes.notificationSettings,
    lazy: async () => {
      const { AccountNotificationSettingsPage } =
        await import("./pages/notification-settings/AccountNotificationSettingsPage");

      return {
        element: (
          <RequireAuth permission={canAccessAccountNotificationSettings}>
            <RequireFeatureFlag flag="isMonthlyLivingExperienceReportEmailEnabled">
              <AccountNotificationSettingsPage />
            </RequireFeatureFlag>
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
